module.exports = __webpack_public_path__ + "media/images/flags/al-3dd8853b91d6f490b4c1429d31c80dee.svg";